@import '../../../globals/main.scss';

pn-bonus-progressbar {
  width: 100%;
}

.bonusprogressbar-top {
  display: flex;
  align-items: center;
  margin-bottom: 1.6rem;
}

.bonusprogressbar-top-icon {
  border-radius: 100%;
  height: 5rem;
  width: 5rem;
  padding: 1rem;
  display: inline-flex;
  margin-right: 1em;
  margin-left: 0.5em;
  background-color: #e0f8ff;
  [theme='red'] & {
    background-color: #fbc2c1;
  }
  pn-icon svg {
    width: 100%;
    height: 100%;
  }
}
.bonusprogressbar-top-heading {
}
.bonusprogressbar-top-headline {
}

.bonusprogressbar-sumtext {
  margin-top: 0.4rem;
  font-size: 1.3rem;
  color: $gray700;
}
.bonusprogressbar-top-percentage {
  //margin-left:auto;
  margin-left: 0.8rem;
  padding: 0;
}

.bonusprogressbar-wrapper {
  position: relative;
  display: flex;
  min-height: 5em;
  align-items: center;
}

.bonusprogressbar-currentlevel {
  position: absolute;
}
.bonusprogressbar-progress[value] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  width: 100%;
  height: 1.7rem;

  border: 0.1rem solid #00a0d6;
  [theme='red'] & {
    border-color: #f06365;
  }
  border-radius: 1.7rem;
  padding: 0;
  margin: 0;
  overflow: hidden;
  &::-webkit-progress-bar {
    border: 0;
    border-radius: 1.7rem;
    margin: 0;
    padding: 0;
    background: #e0f8ff;

    [theme='red'] & {
      background: #fdefee;
    }
  }
  &::-webkit-progress-value {
    margin: 0;
    padding: 0;
    border-radius: 1.7rem;
    background: #00a0d6;
    [theme='red'] & {
      background: #f06365;
    }
  }
}
